import { createAction, props } from '@ngrx/store';

import { PagedResponse } from '@lib/core/models/paged-response';

import { GuaranteeApplication, GuaranteeApplicationSearchModel } from '../models/guarantee-application.interface';
import {
  PersonalDoctorMetadata,
  PharmacologicalItemMetaData,
  Prescription,
  PrescriptionCreateRequest,
  PrescriptionItem,
  PrescriptionTypes,
  ServiceMetadata,
} from '../models/prescription.interface';

export const savePrescription = createAction('[Prescriptions Page] Save prescription');
export const editPrescription = createAction('[Prescriptions Page] Edit prescription', props<{ editData: Prescription }>());
export const deletePrescription = createAction('[Prescriptions Page] Delete prescription', props<{ deletionData: { id: string; type: PrescriptionTypes } | null }>());

export const setPrescriptionsInitRequired = createAction('[Prescriptions Page] Set init required', props<{ initRequired: boolean }>());
export const setPrescriptionsSearchFilter = createAction('[Prescriptions List] Set search filter', props<{ search: string }>());
export const setTargetPrescription = createAction('[Prescriptions List] Set target prescription for highlighting', props<{ prescriptionId: string }>());
export const clearTargetPrescription = createAction('[Prescriptions List] Clear target prescription');

export const setPrescriptionsPage = createAction('[Prescriptions List] Set guarantees page', props<{ page: number }>());
export const incrementPrescriptionsPage = createAction('[Prescriptions List] Increment page');

export const fetchPrescriptions = createAction('[Prescriptions List] Fetch all guarantees', props<Partial<GuaranteeApplicationSearchModel>>());
export const fetchPrescriptionsSuccess = createAction('[Prescriptions List] Fetch all guarantees success', props<{ pagedResponse: PagedResponse<GuaranteeApplication> }>());
export const fetchPrescriptionsFailure = createAction('[Prescriptions List] Fetch all guarantees failure', props<{ error: string }>());

export const processPrescriptionsDrafts = createAction('[Prescriptions Page] Process prescription drafts', props<{ memberId: string }>());
export const processPrescriptionsDraftsSuccess = createAction('[Prescriptions Page] Process prescription drafts success');
export const processPrescriptionsDraftsFailure = createAction('[Prescriptions Page] Process prescription drafts failure', props<{ error: string }>());

export const clearPrescriptions = createAction('[Prescriptions List] Clear prescriptions');
export const resetPrescriptionsState = createAction('[Prescriptions List] Clear prescriptions state');

export const saveAppointment = createAction('[Guarantee] Save appointment', props<{ appointmentId: string }>());
export const saveGuarantee = createAction('[Guarantee] Save guarantee', props<{ description: string; sendGuaranteeNotification: boolean }>());
export const addPrescription = createAction(
  '[Guarantee] Add prescription',
  props<{ prescription: PrescriptionItem<PharmacologicalItemMetaData | ServiceMetadata | PersonalDoctorMetadata> }>()
);
export const removePrescription = createAction('[Guarantee] Remove prescription', props<{ index: number }>());
export const addFreeForm = createAction('[Guarantee] Add free-form prescription', props<{ request: PrescriptionCreateRequest }>());
export const updateFreeForm = createAction('[Guarantee] Update free-form prescription', props<{ index: number; request: PrescriptionCreateRequest }>());
export const removeFreeForm = createAction('[Guarantee] Remove free-form prescription', props<{ index: number }>());
export const clearGuarantee = createAction('[Guarantee] Clear');

export const updatePrescriptionPlanning = createAction(
  '[Prescription] Update prescription planning',
  props<{
    prescriptionId: string;
    planning: {
      id: string;
      planningStatus: string;
      appointmentId?: string;
      doctorId?: string;
      dateStart: string;
      dateEnd: string;
      partnerId?: string;
      locationId?: string;
    };
  }>()
);

export const removePrescriptionPlanning = createAction('[Prescription] Remove prescription planning', props<{ prescriptionId: string }>());

export const refreshPrescriptionsData = createAction('[Prescription] Refresh prescriptions data', props<{ searchParams?: any }>());

export const startPrescriptionsPolling = createAction(
  '[Prescriptions] Start polling for updates',
  props<{ guaranteeId?: string; interval?: number; duration?: number; searchParams?: any }>()
);
export const stopPrescriptionsPolling = createAction('[Prescriptions] Stop polling for updates');

export const silentFetchPrescriptions = createAction('[Prescriptions] Silent fetch (no loading)', props<Partial<GuaranteeApplicationSearchModel>>());
export const silentFetchPrescriptionsSuccess = createAction('[Prescriptions] Silent fetch success', props<{ pagedResponse: PagedResponse<GuaranteeApplication> }>());
